import React from "react";
import { useDroppable } from "@dnd-kit/core";
import GhostItem from "src/components/kanban/GhostItem";
import useKanban from "src/hooks/useKanban";

interface ColumnProps {
	id: string;
	children?: any;
	options?: {
		disabled?: boolean;
	};
	className?: string;
	head?: React.ReactNode;
}

const Column = ({
	id,
	children,
	options,
	className: _className,
	head,
}: ColumnProps) => {
	const { current } = useKanban();
	const { isOver, setNodeRef: ref } = useDroppable({
		id,
	});
	let className = `p-4 transition-all rounded-md flex flex-col ${_className}`;
	if (!className?.includes("bg-")) {
		className += " bg-gray";
	}

	const getDroppableProps = () => {
		if (options?.disabled) return {};
		return {
			ref,
		};
	};

	return (
		<div {...getDroppableProps()} {...{ className }}>
			{head && <div className="mb-3">{head}</div>}
			<div
				{...{ ref }}
				className="flex flex-col flex-1 gap-4 w-[60vw] md:w-[285px] xl:w-[360px]"
			>
				{isOver && current?.from !== id && <GhostItem />}
				{children}
			</div>
		</div>
	);
};

export default Column;
